import {
  PropType,
  computed,
  defineComponent,
} from 'vue';
import MixAddGoods from '~mall/components/MixAddGoods';
import TicketEmpty from '~mall/components/TicketEmpty';
import { TWO_WHEELS_CATEGORY } from '~mall/common/constants/commonConstants';
import { CategoryBizId } from '~mall/constants/bike';
import { getStylesBinder } from '~mall/common/utils/styles';
import store from '~mall/model/store';
import styles from './index.module.less';
import CardListItem from '../bike/CardListItem';
import GoodListItem from '../GoodListItem';
import { CouponMallTabEnum } from '../../enum';

const cx = getStylesBinder(styles);

export default defineComponent({
  name: 'GoodList',
  props: {
    categoryId: {
      type: String,
      required: true,
      default: '',
    },
    categoryName: {
      type: String,
      required: false,
      default: '',
    },
    ridePaySuccess: {
      type: Function as PropType<{ (): void }>,
      default: () => ({}),
    },
    // replaceRideGoods: {
    //   type: Boolean,
    //   required: true,
    // },
    /** 当前是否展示超值推荐 */
    // showHighRecm: {
    //   type: Boolean,
    //   required: true,
    // },
    spuId: {
      type: String,
      default: '',
    },
    /** 奖励金开关状态 */
    rewardSwitchOn: {
      type: Boolean,
      default: false,
    },
  },
  setup: (props, { emit }) => {
    const reqSkuList = (pageNum = 1) => {
      const {
        categoryId,
      } = props;
      return store.dispatch('ticket/actionRequestSkuList', {
        pageNum,
        categoryId,
        // 是否替换全部tab下的两轮骑行卡：AB 实验固化版本为true
        needTwoWheel: true,
      });
    };
    // const isTwBikeDirectBuy = ref(false);
    // const showNps = ref(true);
    // const showNpsPopup = ref(false);
    // const npsIsShowData = ref(false);

    // watch(showNpsPopup, (newVal) => {
    //   // 监听showNpsPopup的值，如果为true，则司南组件弹窗打开
    //   // 调用UBT埋点
    //   if (newVal) {
    //     // nps弹窗模块曝光
    //     UBT.moduleExpose({
    //       pageId: 'couponmall_list',
    //       categoryId: 'hellomall',
    //       moduleId: 'hellomall_NPSfloating',
    //       contentId: 'hellomall_NPSfloating',
    //       exposureTimes: 1,
    //       businessInfo: {},
    //     });
    //     // nps入口点击去评价
    //     UBT.clickButton({
    //       pageId: 'couponmall_list',
    //       buttonName: 'hellomall_NPSevaluate',
    //       categoryId: 'hellomall',
    //       businessInfo: {},
    //     });
    //     // console.log('nps入口点击去评价，弹窗模块曝光，点击去评价点击埋点');
    //   }
    // });

    // const getNpsIsShowData = async () => {
    //   try {
    //     // 调接口获取是否展示nps
    //     // skipExposureFatigueIncrement: true
    //     // 这边访问接口只是为了判断是否展示，所以需要跳过疲劳度计算
    //     const { data = {} } = await npsIsShow({
    //       codeKey: npsIdList[env].codeKey,
    //       surveyId: npsIdList[env].surveyId,
    //       token: storeMgr.userInfo?.token,
    //       skipExposureFatigueIncrement: true,
    //       showServerErr: false, // 不展示服务端业务错误 toast
    //     });
    //     npsIsShowData.value = data.isDisplay;
    //     if (data.isDisplay && props.categoryId === '0') {
    //       // nps入口模块曝光
    //       UBT.moduleExpose({
    //         pageId: 'couponmall_list',
    //         categoryId: 'hellomall',
    //         moduleId: 'hellomall_NPScomponent',
    //         contentId: 'hellomall_NPScomponent',
    //         exposureTimes: 1,
    //         businessInfo: {},
    //       });
    //       // console.log('nps入口模块曝光');
    //     }
    //   } catch (error) {
    //     npsIsShowData.value = false;
    //   }
    // };

    const tabData = computed(() => store.state.ticket.skuDatas?.[props.categoryId] || {});
    const isFirstPageLoadErr = computed(() => tabData.value.isFirstPageLoadErr);
    const showList = computed(() => !!tabData.value.list?.length);
    /** 展示骨架屏 */
    const showSkeleton = computed(() => !tabData.value.list?.length
        && !tabData.value.isLoading
        && !tabData.value.isFirstPageLoadErr
        && !tabData.value.isFirstPageDataOk);
      /** 当前正在展示的商品列表数据 */
    const showingList = computed(() => {
      const { list } = tabData.value;
      const {
        // showHighRecm,
        // categoryId,
        spuId,
      } = props;

      // 猜你喜欢 逻辑只显示第一项
      if (spuId && list.length > 0) {
        const firstTwo = list.slice(0, 2);
        const filteredValue = firstTwo.find((good) => good.spuId !== spuId);
        const likeList = filteredValue ? [filteredValue] : [];
        emit('like-list-length', likeList.length);
        return likeList;
      }

      //   if (showHighRecm && categoryId === '0' && list.length > 2) {
      //     // * 展示超值推荐的情况，且商品数量超过2个，全部tab下过滤前2条数据
      //     return list.slice(2);
      //   }

      return list;
    });

    // 是否展示随心配组件
    // 全部Tab下展示随心配组件
    const showMixAddGoods = computed(() => (props.categoryId === CouponMallTabEnum.ALL));

    const noTicket = computed(() => !showList.value
        && !isFirstPageLoadErr.value
        && tabData.value.isFirstPageDataOk);

    /** 加载是否出错 */
    const loadError = computed<boolean>({
      get() {
        return tabData.value.isPageLoadErr;
      },
      set(value) {
        store.commit('ticket/setSkuDatas', {
          categoryId: props.categoryId,
          ticketTabData: {
            ...tabData.value,
            isPageLoadErr: value,
          },
        });
      },
    });
      /** 上滑刷新 */
    const onLoadList = async () => {
      if (props.spuId) {
        return;
      }
      const {
        isFirstPageDataOk,
        curPage,
      } = tabData.value;

      if (isFirstPageDataOk) {
        await reqSkuList((curPage || 0) + 1);
      }
    };
      /** 更新列表加载状态 */
    const updateLoading = (loading: boolean) => {
      if (props.spuId) {
        return;
      }
      store.commit('ticket/setSkuDatas', {
        categoryId: props.categoryId,
        ticketTabData: {
          ...tabData.value,
          isLoading: loading,
        },
      });
    };
      /** 更新列表错误状态 */
    const updateError = (err: boolean) => {
      loadError.value = err;
    };
    return () => (
        <div class={cx('container')}>
          {showSkeleton.value && (
            <div class={cx('skeleton')}>
                    {Array.from({ length: 10 }, (_, index) => (
                <div key={index} class={cx('skeleton-item')}>
                  <van-skeleton class={cx('skeleton-avatar')} avatar avatar-shape="square" />
                  <van-skeleton class={cx('skeleton-row')} row={3} />
                </div>
                    ))}
            </div>
          )}
          {(() => {
            if (isFirstPageLoadErr.value) {
              return (
                <TicketEmpty
                  class={cx('empty')}
                  imgAttrs={{
                    src: 'https://m.hellobike.com/resource/helloyun/18121/s7R3W_icon_yichang@2x.png',
                    width: '2.7rem',
                    height: '1.6rem',
                  }}
                  desc='网络不太顺畅哦，请刷新页面'
                  hideBtn
                />
              );
            }

            if (noTicket.value) {
              return (
                <div style={{ margin: '0px 12px' }}>
                  {showMixAddGoods.value && <MixAddGoods />}
                  <TicketEmpty
                    class={cx('empty')}
                    hideBtn
                  />
                </div>
              );
            }

            if (showList.value) {
              const {
                isLoading,
                hasMore,
                traceId,
              } = tabData.value;
              const { value } = showingList;
              return (
                <van-list
                  loading={isLoading}
                  finished={!hasMore}
                  immediate-check={false}
                  error={loadError.value}
                  error-text="请求失败，点击重新加载"
                  onInput={updateLoading}
                  onLoad={onLoadList}
                  {...{ on: { 'update:error': updateError } }}
                >
                  {value.map((good, goodIndex) => (
                    <div class={cx('good')}>{(() => {
                      const {
                        twoWheelCard,
                        categoryId,
                        categoryName,
                      } = good;

                      if (twoWheelCard) {
                        const {
                          channelCode,
                          ...pkgData
                        } = twoWheelCard;
                        const data = {
                          ...pkgData,
                          categoryName,
                        };
                        return (
                          <div>
                            <CardListItem
                              key={goodIndex}
                              data={data}
                              skuIndex={goodIndex}
                              channelCode={channelCode}
                              bizId={CategoryBizId[categoryId as TWO_WHEELS_CATEGORY]}
                              paySuccessCb={props.ridePaySuccess}
                              categoryName={categoryName}
                              tabCategoryName={props.categoryName}
                              categoryId={categoryId}
                              traceId={traceId}
                            />
                          </div>
                        );
                      }

                      return (
                        <GoodListItem
                          key={goodIndex}
                          skuData={good}
                          skuIndex={goodIndex}
                          categoryName={props.categoryName}
                          tabCategoryName={props.categoryName}
                          categoryId={categoryId}
                          listProps={props}
                          traceId={traceId}
                          rewardSwitchOn={props.rewardSwitchOn}
                        />
                      );
                    })()}
                    {/* 随心配投放位置：首屏第5个商品下,若当前业务线商品不足5个，则放在最后一个商品下 */}
                    {(goodIndex === 4 || (goodIndex === value.length - 1 && value.length < 5))
                     && showMixAddGoods.value
                     && (
                        <MixAddGoods />
                     )}
                  </div>
                  ))}
                </van-list>
              );
            }

            return null;
          })()}
        </div>
    );
  },
});
